export const getSignUp = (state) => state.auth.signUp;
export const getLoading = (state) => state.auth.signUp.loading;
export const getErrors = (state) => state.auth.signUp.errors;
export const getReCaptchaV2 = (state) => state.auth.signUp.reCaptchaV2;
export const getReCaptchaV3 = (state) => state.auth.signUp.reCaptchaV3;
